import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { Drawer } from "../../../components/Drawer";
import { Spacing } from "../../../theme/Spacing";
import { AtiraTabs } from "../../../components/AtiraTabs";
import { KanbanCardDrawerInfoTab } from "./kanbanCardDetailsDrawerTabs/KanbanCardDrawerInfoTab";
import { KanbanCardDrawerActivityTab } from "./kanbanCardDetailsDrawerTabs/KanbanCardDrawerActivityTab";
import { useDrawersContext } from "../../tasks/drawers-context";
import { useAppDispatch, useAppSelector } from "../../../redux/store";
import { userSliceSelectors } from "../../../redux/user/user.selector";
import { kanbanActions } from "../../../redux/kanban/kanban.slice";

const StyledTabs = styled(AtiraTabs)`
  padding-inline: 0;
  padding-top: ${Spacing.s};
  height: 100%;

  .ant-tabs-content,
  .ant-tabs-tabpane-active {
    height: 100%;
  }

  .ant-tabs-nav::before {
    display: none;
  }

  .ant-tabs-nav-list {
    width: 100% !important;
    justify-content: space-between !important;
  }

  .ant-tabs-tab {
    flex-grow: 1;
    justify-content: center;
  }
`;

export const KanbanCardReadDrawer: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const {
    kanbanCard,
    setKanbanCard,
    kanbanCardReadVisible,
    setKanbanCardReadVisible,
  } = useDrawersContext();

  const userId = useAppSelector(userSliceSelectors.selectLoggedInUserId)!;

  const items = [
    {
      key: "info",
      label: t("common.info"),
      children: <KanbanCardDrawerInfoTab />,
    },
    {
      key: "activity",
      label: t("common.activity"),
      children: <KanbanCardDrawerActivityTab />,
    },
  ];

  const localOnClose = () => {
    setKanbanCardReadVisible(false);
    setKanbanCard(null);
  };

  useEffect(() => {
    if (kanbanCard?._id && kanbanCardReadVisible) {
      const fetchCard = async () => {
        const card = await dispatch(
          kanbanActions.getKanbanCardById({ cardId: kanbanCard._id!, userId }),
        ).unwrap();
        if (card) {
          setKanbanCard(card);
        }
      };

      fetchCard();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kanbanCard?._id, kanbanCardReadVisible]);

  if (!kanbanCard) {
    return null;
  }

  return (
    <Drawer
      title={t("deals.darwer.preview.title")}
      open={kanbanCardReadVisible}
      onClose={localOnClose}
      width={"35rem"}
    >
      <StyledTabs items={items} />
    </Drawer>
  );
};
